import { render } from "./AddAcademy.vue?vue&type=template&id=31de5d4c"
import script from "./AddAcademy.vue?vue&type=script&lang=js"
export * from "./AddAcademy.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__